export const ACCEPTED_EXTS = ["jpg", "jpeg", "png", "svg", "otf", "ttf", "woff", "woff2"];

export const ACCEPTED_INPUT_ACCEPT = ACCEPTED_EXTS.map((e) => `.${e}`).join(",");

export function isAcceptedFile(file: File): boolean {
  const ext = file.name.split(".").pop()?.toLowerCase() || "";
  return ACCEPTED_EXTS.includes(ext);
}
